import { buttonProps } from './button'

import type { ExtractPropTypes } from 'vue'
import type buttonGroup from './button-group.vue'

export const buttonGroupProps = {
  size: { ...buttonProps.size, default: 'small' },
  type: { ...buttonProps.type, default: 'ghost' },
  rounded: Boolean,
  compact: Boolean,
} as const
export type ButtonGroupProps = ExtractPropTypes<typeof buttonGroupProps>

export type ButtonGroupInstance = InstanceType<typeof buttonGroup>
